import {ChatbotAvailableProfileRepresentation} from './chatbot-available-profile-representation';

export class ChatbotAvailableProfile {

  private _keycloakId: string;
  private _firstName: string;
  private _lastName: string;

  constructor(keycloakId: string,
              firstName: string,
              lastName: string) {
    this._keycloakId = keycloakId;
    this._firstName = firstName;
    this._lastName = lastName;
  }

  get keycloakId(): string {
    return this._keycloakId;
  }

  get firstName(): string {
    return this._firstName;
  }

  get lastName(): string {
    return this._lastName;
  }

  static buildFrom(chatbotAvailableProfileRepresentation: ChatbotAvailableProfileRepresentation): ChatbotAvailableProfile{
    return new ChatbotAvailableProfile(
      chatbotAvailableProfileRepresentation.keycloakId,
      chatbotAvailableProfileRepresentation.firstName,
      chatbotAvailableProfileRepresentation.lastName
    );
  }
}
